import OnClickToolButton from 'app/components/ToolsBar/OnClickToolButton';
import React from 'react';
import { Icon } from 'semantic-ui-react';

type AnnotationsDisplaySwitchButtonProps = {
  onSwitchAnnotationState: () => void;
  showAnnotations: boolean;
};

export default function AnnotationsDisplaySwitchButton({
  onSwitchAnnotationState,
  showAnnotations,
}: AnnotationsDisplaySwitchButtonProps) {
  return (
    <OnClickToolButton
      onClick={onSwitchAnnotationState}
      tooltipId="tools.show_hide_annotations.tooltip"
      content={<Icon name={showAnnotations ? 'eye' : 'eye slash'} />}
    />
  );
}
